var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "sidebarFilter" },
    [
      _c("p", { staticClass: "sidebarFilter__desc" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.trans("FORM_FILTER_LOCATION_TEXT")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "entity__headline entity__headline--dark margin-bottom-10",
        },
        [
          _c("label", { attrs: { for: "isoregion" } }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("FORM_SEARCH_REGIONS")) +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("CustomDropdownB", {
        attrs: {
          id: "inlineDropdown__location",
          "data-gtm": "sidebarFilter__location",
          value: _vm.selectedRegion,
          options: _vm.isoregionsData,
          default: _vm.isoregionsData[0],
          element: "sidebarFilter__location",
          bordered: true,
        },
        on: { changeValue: _vm.selectLocation },
      }),
      _vm._v(" "),
      _vm.showSearchField
        ? _c(
            "div",
            { staticClass: "sidebarFilter__countries" },
            [
              _c(
                "p",
                {
                  staticClass:
                    "entity__headline entity__headline--dark margin-top-10",
                  attrs: { id: "isocountriesTitle" },
                },
                [
                  _c(
                    "label",
                    { staticClass: "required", attrs: { for: "isocountries" } },
                    [_vm._v(_vm._s(_vm.trans("FORM_COUNTRIES_TERRITORIES")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("SelectSearchable", {
                attrs: {
                  id: "isocountries",
                  options: _vm.filteredCountries,
                  "option-id-prefix": "isocountry_",
                  "show-search": true,
                  "show-tags": false,
                  name: "isocountries[]",
                  "search-placeholder": _vm.trans("FORM_COUNTRY_SEARCH"),
                  "search-name": "isocountrySearch",
                  "search-id": "isocountrySearch",
                  "search-input-labelled-by": "isocountriesTitle",
                },
                on: { select: _vm.setSelectedCountry },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "selectedCountries flex facetedSearch__content",
                },
                _vm._l(_vm.selectedCountries, function (country) {
                  return _c(
                    "button",
                    {
                      key: country.value,
                      staticClass:
                        "facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center",
                      attrs: {
                        type: "button",
                        "data-gtm": `sidebarPill__${country.name}`,
                        "aria-label": _vm.trans("FORM_FILTER_LOCATION_PILL", {
                          "{countryName}": country.name,
                        }),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeCountry(country.value)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(country.name) +
                          "\n                "
                      ),
                      _c(
                        "svg",
                        {
                          staticClass: "pill__icon",
                          attrs: {
                            height: "16",
                            width: "16",
                            "aria-hidden": "true",
                          },
                        },
                        [_c("use", { attrs: { href: "#iconCrossBold" } })]
                      ),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }